import _jsx from "@babel/runtime/helpers/jsx";
var _div;
import React from 'react';
import { Heading } from 'reaxl';
function VHRLeadHeading() {
  return _div || (_div = /*#__PURE__*/_jsx("div", {
    className: "margin-bottom-4"
  }, void 0, /*#__PURE__*/_jsx(Heading, {
    size: 400,
    className: "margin-bottom-2"
  }, void 0, "Get a Free Report in Seconds"), /*#__PURE__*/_jsx("p", {}, void 0, "We'll let the dealer know you're interested in learning more about the history of this vehicle.")));
}
export default VHRLeadHeading;